module.exports = __webpack_public_path__ + "img/perfil.8bedf5b0.svg";